import styled, { css } from 'styled-components';
import { LEFT_SIDEBAR_WIDTH } from './../Layout/constants';

interface iWrapper {
  show: boolean;
  animationDuration: number;
}

export const MovingPart = styled.div``;

export const Wrapper = styled.div<iWrapper>`
  position: fixed;
  left: 0;
  bottom: 0;
  height: calc(
    ${({ theme }) => theme.spacing.km14} + ${({ theme }) => theme.spacing.km16} +
      ${({ theme }) => theme.spacing.km16}
  );
  overflow: hidden;
  width: 100%;

  ${MovingPart} {
    position: absolute;
    bottom: ${({ theme }) => `-${theme.spacing.km14}`};
    left: 0;
    padding: 0 10px;
    transition: ease ${({ animationDuration }) => `${animationDuration}ms`};

    @media (min-width: ${({ theme }) => theme.breakpoint.lg.minWidth}) {
      left: ${({ theme }) =>
        `calc(${LEFT_SIDEBAR_WIDTH} + ${theme.spacing.km12})`};
      padding: 0;
    }

    ${({ show }) =>
      show &&
      css`
        bottom: ${({ theme }) => theme.spacing.km14};
      `}
  }
`;
